export default __webpack_public_path__ + "static/media/TL.4a8491b1.webp";